export default "__VITE_ASSET__1454feaf__"